import { render, staticRenderFns } from "./organizationInfo.vue?vue&type=template&id=12308540&scoped=true"
import script from "./organizationInfo.vue?vue&type=script&lang=js"
export * from "./organizationInfo.vue?vue&type=script&lang=js"
import style0 from "./organizationInfo.vue?vue&type=style&index=0&id=12308540&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12308540",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12308540')) {
      api.createRecord('12308540', component.options)
    } else {
      api.reload('12308540', component.options)
    }
    module.hot.accept("./organizationInfo.vue?vue&type=template&id=12308540&scoped=true", function () {
      api.rerender('12308540', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/organizationChild/organizationInfo.vue"
export default component.exports